import { useAutocomplete } from 'admin';
import type { AllowedMaterialSpec } from 'api';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export type MaterialAutocompleteProps = { defaultValue?: AllowedMaterialSpec['id'] } & Omit<
  AutocompleteFieldProps<AllowedMaterialSpec>,
  'options' | 'defaultValue'
>;

export const AllowedMaterialSpecAutocomplete = ({ defaultValue, ...props }: MaterialAutocompleteProps) => {
  const { autocompleteProps } = useAutocomplete<AllowedMaterialSpec>({
    defaultValue: defaultValue,
    onSearch: (value) => [
      {
        field: 'search',
        operator: 'contains',
        value,
      },
    ],
    resource: '/materials/v1/allowed-material-specs/',
  });

  return (
    <AutocompleteField<AllowedMaterialSpec>
      {...autocompleteProps}
      {...props}
      getOptionLabel={(option) => option.name}
      valueField="id"
      data-testid="allowed-material-spec-autocomplete"
    />
  );
};
